import { api } from "@/openapi/client";
import { ApiResponseError } from "@/lib/error";
import { getCacheTags } from "@/lib/cache-utils";
import { userQueryKeys } from "@/app/[locale]/(auth)/user/_api/user-query-keys";

// Use existing pattern from components schemas with all transaction statuses
export interface UserDonationSummaryDto {
    validatedAmount: number;
    pendingAmount: number;
    receivedAmount: number;
    deniedAmount: number;
    deletedAmount: number;
    totalAmount: number;
    currency: string;
}

/**
 * Fetch the donation summary for the authenticated user.
 * Uses the client-side API for read operations.
 */
export async function getUserDonationSummary(
  client: typeof api = api
): Promise<UserDonationSummaryDto> {
    const { data, error } = await client.GET("/users/donations/summary", {
        next: { tags: getCacheTags(userQueryKeys.donationSummary()) },
        // Note: No 'cache: force-cache' since this is user-specific authenticated data
    });
    
    if (error) throw error;
    if (!data) throw new ApiResponseError("getUserDonationSummary");
    
    return data as UserDonationSummaryDto;
}